import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'learning-of-statement';

const ELEMENTS = define({
  CREATE_BUTTON: ['create', 'button'],
  LOS_NAME_INPUT: ['los-name', 'input'],
  SUBMIT_BUTTON: ['submit', 'button'],
  LEVEL_ITEM_ROW: ['level-item', 'row'],
  ROW_ACTION_EDIT: ['row-action-edit', 'menu-item'],
  ROW_ACTION_DELETE: ['row-action-delete', 'menu-item'],
  ROW_ACTION_DISABLE: ['row-action-disable', 'menu-item'],
});

export const LOS_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
